const timeConstants = {
  GET_TIME: 'GET_TIME',
  GET_DATE: 'GET_DATE',
};

export default timeConstants;
